const AddNode = (content, node) => {
  var next_id = Math.max(...Object.values(content).map((item) => item.id)) + 1
  node.id = next_id
  content[next_id] = node
  return content
}

export default AddNode